module.exports = [{
      plugin: require('/Users/hokkinfong/code/blupurple/ift-annual-report-website-2018/node_modules/gatsby-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".mdx",".md"],"defaultLayouts":{"default":"/Users/hokkinfong/code/blupurple/ift-annual-report-website-2018/src/layouts/markdown-page.js"}},
    },{
      plugin: require('/Users/hokkinfong/code/blupurple/ift-annual-report-website-2018/node_modules/gatsby-plugin-nprogress/gatsby-browser.js'),
      options: {"plugins":[],"color":"orange","showSpinner":false,"trickle":false,"minimum":0.2},
    },{
      plugin: require('/Users/hokkinfong/code/blupurple/ift-annual-report-website-2018/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
